const isTouchScreenDevice = () => {
  if (typeof window === "undefined") {
    return false // Rendu côté serveur, pas de support pour les écrans tactiles
  }

  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}

const isSmallScreenDevice = () => {
  if (typeof window === "undefined") {
    return false // Rendu côté serveur, taille de l'écran inconnue
  }

  return window.innerWidth <= 1080
}

const isUserAgentTouchScreenDevice = () => {
  if (typeof window === "undefined") {
    return false // Rendu côté serveur, pas de support pour les écrans tactiles
  }

  const userAgent = navigator.userAgent.toLowerCase()
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  )
}

const isMobileDevice = () => {
  const isScreenMobile = isSmallScreenDevice()
  const isTouchScreen = isTouchScreenDevice()
  const isMobileUserAgent = isUserAgentTouchScreenDevice()

  return isScreenMobile || isTouchScreen || isMobileUserAgent
}

module.exports = {
  isTouchScreenDevice,
  isSmallScreenDevice,
  isUserAgentTouchScreenDevice,
  isMobileDevice,
}
